import { designSystemColors } from '@klv/shared/styles/colors';

import type { IVideoModalTriggerTheme } from '../../types';

const videoModalTrigger: IVideoModalTriggerTheme = {
  base: {
    backgroundColor: 'rgba(0, 0, 0, 0.15)',
    buttonBackgroundColor: 'rgba(0, 0, 0, 0.30)',
    buttonBorderColor: designSystemColors.white,
    buttonTextColor: designSystemColors.white,
  },
  hover: {
    backgroundColor: 'rgba(0, 0, 0, 0.30)',
    buttonBackgroundColor: 'rgba(255, 255, 255, 1)',
    buttonBorderColor: designSystemColors.white,
    buttonTextColor: designSystemColors.charcoal,
  },
};

export default videoModalTrigger;
